<template>
  <v-dialog
    :value="true"
    max-width="600"
    persistent
  >
    <avs-card subtitle>
      <template v-slot:title>
        <v-card-title class="pa-0"> {{ $t("views.company.title") }} </v-card-title>
      </template>
      <template v-slot:subtitle>
        <v-card-subtitle class="pl-0">{{ $t("views.company.subtitle") }}</v-card-subtitle>
      </template>
      <template v-slot:content>
        <v-card-text class="pt-0">
          <div style="display: flex; align-items: center">
            <v-select
              style="width: 300px"
              v-model="selected"
              :items="items"
              item-text="name"
              :label="$t('categories.company.name')"
              dense
              outlined
              return-object
              hide-details="false"
            ></v-select>
            <avs-button
              class="ml-2"
              color="blue white--text"
              iconI="mdi-check-circle-outline"
              noSpantext
              :disabled="!selected"
              @click="setCompany"
            >
              <template v-slot:name>{{ $t("commons.ok") }}</template>
            </avs-button>
          </div>
        </v-card-text>
      </template>
    </avs-card>
  </v-dialog>
</template>

<script>
import CompanyService from "@/services/CompanyService"

export default {
  name: "CompanySelector",
  data() {
    return {
      items: [],
      selected: null
    }
  },
  methods: {
    fetchCompanies() {
      CompanyService.getAll().then(results => {
        this.items = results
      })
    },
    setCompany() {
      const redirect = this.$route.query.redirect || { name: "Home" }
      this.$store.commit("app/setCompany", this.selected)
      this.$store.commit("app/clearProject")
      this.$router.push(redirect)
    }
  },
  mounted() {
    this.fetchCompanies()
  }
}
</script>
